const component = {
  template: `
    <div class="portalHeader" ng-class="$ctrl.isFull ? 'portalHeader--tall' : ''">
      <div ng-hide="$ctrl.gradient === false" class="portalHeader__gradient"></div>

      <div class="portalHeader__backgroundImg" style="background-image: url(//cdn.startupmedia.com/greenback/entities/{{$ctrl.id}}/portal_header.jpg);"></div>
      <div class="portalHeader__logo">

        <img ng-if="!$ctrl.cause.subentity" class="portalHeader__logoImg" ng-class="$ctrl.headerTxt ? 'portalHeader__logoImg--small' : ''"el-entity-img="{{$ctrl.id}}" ng-src={{src}}>

        <img ng-if="$ctrl.cause.subentity" class="portalHeader__logoImg" ng-class="$ctrl.headerTxt ? 'portalHeader__logoImg--small' : ''" ng-src="//cdn.startupmedia.com/greenback/entities/{{$ctrl.id}}/{{$ctrl.cause.subentity.id}}/logo" default-sponsor-logo="//cdn.startupmedia.com/greenback/entities/{{$ctrl.id}}/0/logo">

        <div class="portalHeader__txt" ng-bind-html="$ctrl.headerTxt"></div>
      </div>
    </div>
  `,
  bindings: {
    id: '@',
    entityType: '@',
    headerTxt: '@',
    isFull: '@',
    cause: '<',
    gradient: '<'
  },
  controller() {
    this.$onInit = () => {
      console.log(this.cause)
    };
  }
};

export default component;



// WEBPACK FOOTER //
// ./js/containers/causePortal/components/portalHeader/index.js